$(document).ready(function() {
    $(document).on('click', '.js-filter-item', function() {
        $('.js-filter-item').removeClass('active');
        $(this).addClass('active');
    });
});


// WEBPACK FOOTER //
// ./src/js/general/filter.js